module.exports = __webpack_public_path__ + "img/votronic_20A.98b3a1fd.png";